import { Turbo } from "@hotwired/turbo-rails"
import * as ActiveStorage from "@rails/activestorage"
import "./controllers"
import "./turbo-mount"

ActiveStorage.start()

const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)

if (document.startViewTransition && !isIOS) {
  addEventListener("turbo:before-frame-render", (event) => {
    const originalRender = event.detail.render
    event.detail.render = (currentElement, newElement) => {
      document.startViewTransition(() => originalRender(currentElement, newElement))
    }
  })
}

Turbo.StreamActions.redirect = function () {
  Turbo.visit(this.target, { frame: '_top', action: 'advance' })
}

Turbo.StreamActions.reloadFrames = function () {
  const id     = this.getAttribute("target") || this.target
  const frame  = document.getElementById(id)
  if (frame && frame.reload) frame.reload()
}
